import moment from 'moment'
import PropTypes from 'prop-types'
import React, { Component, Fragment } from 'react'
import DatepickerInput from './datepicker-input.component'
import { SelectInput } from './inputs.component'

const ALLOWED_RANGE_IN_MONTHS = 60

/**
 * Regras de disponibilidade dos dias no calendário — o passado recente é selecionável, HOJE é
 * selecionável, e o futuro não.
 *
 * Toda comparação é feita com granularidade de DIA, de propósito. O react-dates entrega cada dia
 * normalizado ao MEIO-DIA (`getCalendarMonthWeeks` usa `.hour(12)`), então comparar contra
 * `moment()` — que carrega a hora corrente — fazia a régua andar durante o dia: às 10h35, "hoje ao
 * meio-dia" era considerado futuro e o próprio dia de hoje aparecia indisponível, mesmo sendo o
 * valor que o campo já trazia preenchido; depois das 12h ele voltava a funcionar. Com `'day'` o
 * resultado é o mesmo às 00h01 e às 23h59, e amanhã NUNCA é liberado.
 */
export const isOutsideInitialRange = (value, now = moment()) =>
	value.isAfter(now, 'day') ||
	value.isBefore(now.clone().add(-ALLOWED_RANGE_IN_MONTHS, 'M'), 'day')

export const isOutsideFinalRange = (value, initialDate, now = moment()) =>
	value.isBefore(moment(initialDate, 'DD/MM/YYYY'), 'day') || value.isAfter(now, 'day')

/**
 * @param {string} initialDate intial date "DD/MM/YYYY"
 * @param {string} finalDate final date "DD/MM/YYYY"
 * @param {function} initialDateIsOutSideRange function to defines if initial date is outside range
 * @param {function} finalDateIsOutSideRange function to defines if final date is outside range
 */
class PeriodInputs extends Component {
	constructor(props) {
		super(props)
		moment.locale('pt-br')
		this.state = {
			period: 30,
			initialDate:
				props.initialDate ||
				moment()
					.subtract(30, 'days')
					.format('DD/MM/YYYY'),
			finalDate: props.finalDate || moment().format('DD/MM/YYYY')
		}
	}

	onPeriodValueChange = value => {
		if (!value || value == 'none') return

		const currentDate = moment().format('DD/MM/YYYY')
		const calculatedDate = moment()
			.subtract(value, 'days')
			.format('DD/MM/YYYY')

		this.setState({
			initialDate: calculatedDate,
			finalDate: currentDate
		})
	}

	shouldComponentUpdate(nextProps, nextState) {
		const { initialDate, finalDate } = this.state
		return (
			initialDate != nextState.initialDate ||
			finalDate != nextState.finalDate
		)
	}

	setFinalDate = finalDate => this.setState({ finalDate })

	onDateChange = () => {
		const { setFieldValue } = this.props
		setFieldValue('period', periodOptions[4].value)
	}

	render() {
		const { initialDate, finalDate } = this.state
		const {
			initialDateIsOutSideRange,
			finalDateIsOutSideRange,
			classNameSelect,
			classNameFrom,
			classNameTo
		} = this.props
		return (
			<Fragment>
				<SelectInput
					id="period"
					label="Período"
					defaultValue={periodOptions[0]}
					options={periodOptions}
					multi={false}
					onValueChange={this.onPeriodValueChange}
					className={classNameSelect}
					{...this.props}
				/>
				<DatepickerInput
					id="initialDate"
					label="De"
					date={initialDate}
					onValueChange={date => {
						const newDate = date.format('DD/MM/YYYY')
						this.setState({ initialDate: newDate })
						if (date.isAfter(moment(finalDate, 'DD/MM/YYYY'))) {
							this.setState({ finalDate: newDate })
						}

						this.onDateChange()
					}}
					isOutsideRange={value =>
						initialDateIsOutSideRange
							? initialDateIsOutSideRange(value, finalDate)
							: isOutsideInitialRange(value)
					}
					className={classNameFrom}
					{...this.props}
				/>
				<DatepickerInput
					id="finalDate"
					label="Até"
					date={finalDate}
					onValueChange={date => {
						this.setState({ finalDate: date.format('DD/MM/YYYY') })
						this.onDateChange()
					}}
					isOutsideRange={value =>
						finalDateIsOutSideRange
							? finalDateIsOutSideRange(value, initialDate)
							: isOutsideFinalRange(value, initialDate)
					}
					className={classNameTo}
					{...this.props}
				/>
			</Fragment>
		)
	}
}

PeriodInputs.propTypes = {
	initialDate: PropTypes.string,
	finalDate: PropTypes.string
}

const periodOptions = [
	{ value: '30', label: 'Últimos 30 dias' },
	{ value: '60', label: 'Últimos 60 dias' },
	{ value: '90', label: 'Últimos 90 dias' },
	{ value: '120', label: 'Últimos 120 dias' },
	{ value: 'none', label: 'Personalizado' }
]

export const periodInitialValues = {
	period: 30,
	initialDate: moment()
		.subtract(30, 'days')
		.format('YYYY/MM/DD'),
	finalDate: moment().format('YYYY/MM/DD')
}

export default PeriodInputs
